<template>
  <div class="folder-structure-wrapper">
    <div
      :class="`d-flex align-items-center position-relative py-2 pr-2 ${isActiveWrapper ? 'active-structure-wrapper' : ''}`"
      :style="{ 'padding-left': `${15 + (value.nestingCount + 1) * 18}px` }"
    >
      <div @click="() => onChangeTreeHandler(value)" :class="{ invisible: value.type === 'file' }">
        <CollapseIcon
          :class="value.isOpen || isActiveWrapper ? `active-collapse ${value.isOpen ? 'active-collapse-icon' : ''}` : 'disable-collapse'"
        />
      </div>
      <div class="d-flex align-items cursor-pointer" @click="() => onSelectedStructure(value)">
        <FolderIcon
          v-if="value.type === 'folder'"
          :class="value.isOpen || isActiveWrapper ? 'active-folder-icon' : 'disable-folder-icon'"
        />
        <component :is="fileIcons[value.fileType] || fileIcons['*']" v-if="value.type === 'file'" class="files-icon" />
        <RootFolderIcon v-if="value.type === 'rootFolder'" class="active-folder-icon" />
      </div>
      <p
        :class="`cursor-pointer folder-name ${value.isOpen || isActiveWrapper ? 'folder-name-active' : ''}`"
        @click="() => onSelectedStructure(value)"
      >
        {{ value.name }}
      </p>
      <div v-if="value.type !== 'rootFolder'" class="ml-auto w-16">
        <DragAndDropIcon class="ml-auto drag-and-drop" />
      </div>
      <StructurePathIcon v-if="isActiveWrapper" class="position-absolute pointer-wrapper" />
    </div>
    <div v-if="value.isOpen">
      <draggable
        :list="value.childList"
        handle=".drag-and-drop"
        ghost-class="ghost"
        @change="changeStructureOrder"
      >
        <FolderStructureTree
          v-for="childValue in value.childList"
          :key="childValue.id"
          :value="childValue"
          :on-change-tree-handler="onChangeTreeHandler"
          :selected-structure="selectedStructure"
          :on-selected-structure="onSelectedStructure"
        />
      </draggable>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable';

import CollapseIcon from '../../../../assets/icons/iconsCode/collapse.vue';
import FolderIcon from '../../../../assets/icons/iconsCode/folder.vue';
import JpgFileIcon from '../../../../assets/icons/iconsCode/jpg-file.vue';
import PngFileIcon from '../../../../assets/icons/iconsCode/png-file.vue';
import PptFileIcon from '../../../../assets/icons/iconsCode/ppt-file.vue';
import TxtFileIcon from '../../../../assets/icons/iconsCode/txt-file.vue';
import XlsFileIcon from '../../../../assets/icons/iconsCode/xls-file.vue';
import DocFileIcon from '../../../../assets/icons/iconsCode/doc-file.vue';
import PdfFileIcon from '../../../../assets/icons/iconsCode/pdf-file.vue';
import ZipFileIcon from '../../../../assets/icons/iconsCode/zip-file.vue';
import UnknownFileIcon from '../../../../assets/icons/iconsCode/unknown-file.vue';
import RootFolderIcon from '../../../../assets/icons/iconsCode/root-folder.vue';
import StructurePathIcon from '../../../../assets/icons/iconsCode/structure-path.vue';
import DragAndDropIcon from '../../../../assets/icons/iconsCode/drag-and-drop.vue';
import api from '../../../api';
import { NotificationMixin } from '../../../../mixins';

export default {
  name: 'FolderStructureTree',
  components: {
    CollapseIcon,
    FolderIcon,
    JpgFileIcon,
    RootFolderIcon,
    PngFileIcon,
    PptFileIcon,
    TxtFileIcon,
    XlsFileIcon,
    DocFileIcon,
    PdfFileIcon,
    ZipFileIcon,
    StructurePathIcon,
    UnknownFileIcon,
    draggable,
    DragAndDropIcon,
  },
  mixins: [NotificationMixin],
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    onChangeTreeHandler: {
      type: Function,
      default: () => {},
    },
    selectedStructure: {
      type: Object,
      default: () => {},
    },
    onSelectedStructure: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  computed: {
    isActiveWrapper() {
      return this.selectedStructure.id === this.value.id;
    },
    fileIcons() {
      return {
        'image/jpeg': JpgFileIcon,
        'image/png': PngFileIcon,
        'application/vnd.ms-powerpoint': PptFileIcon,
        'application/vnd.openxmlformats-officedocument.presentationml.presentation': PptFileIcon,
        'text/plain': TxtFileIcon,
        'application/vnd.ms-excel': XlsFileIcon,
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': XlsFileIcon,
        'application/msword': DocFileIcon,
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': DocFileIcon,
        'application/pdf': PdfFileIcon,
        'application/zip': ZipFileIcon,
        'application/x-zip-compressed': ZipFileIcon,
        '*': UnknownFileIcon,
      };
    },
  },
  methods: {
    async changeStructureOrder() {
      try {
        await api.viewStructure.changeStructureOrder({ renewedList: this.value.childList.map(({ id }) => id)});

        this.showNotification({ type: 'success', message: 'Structure order has been successfully updated' });
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.active-collapse {
  color: #2260FF;
  margin-right: 8px;
  cursor: pointer;
}
.active-collapse-icon {
  transform: rotate(90deg);
}
.disable-collapse {
  color: #C5D0DE;
  margin-right: 8px;
  cursor: pointer;
}
.active-folder-icon {
  color: #2260FF;
  margin-right: 10px;
}
.disable-folder-icon {
  color: #C5D0DE;
  margin-right: 10px;
}
.files-icon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
.folder-name {
  color: #646A87;
  font-family: 'Poppins';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin-right: 4px;
}
.folder-name-active {
  color: #2260FF;
}
.active-structure-wrapper {
  border-radius: 4px;
  background-color: #e9edf3;
}
.pointer-wrapper {
  right: -13px;
  top: -3px;
}
.folder-structure-wrapper {
  background-color: #f9fafb;
  border-radius: 4px;
}
.drag-and-drop {
  cursor: grab;
  margin-top: -3px;
}
.ghost {
  border-radius: 0;
  border-bottom: 2px solid #2260FF;
  margin-bottom: -2px;
}
.ghost > div {
  opacity: 0.1;
}
.ghost::after {
  content: '';
  position: absolute;
  background-color: #2260FF;
  height: 9px;
  width: 2px;
  right: 0;
  bottom: -5.5px;
  border-radius: 8px;
}
.ghost::before {
  content: '';
  position: absolute;
  background-color: #2260FF;
  height: 9px;
  width: 2px;
  left: 0;
  bottom: -5.5px;
  border-radius: 8px;
}
.w-16 {
  width: 16px;
}
</style>
